export default __webpack_public_path__ + "static/uk_main-c63b82d7d3e9719d4b72f90b83a28be0.png";